import { render } from "./MessageThread.vue?vue&type=template&id=1ed22ae9"
import script from "./MessageThread.vue?vue&type=script&lang=js"
export * from "./MessageThread.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__